
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'Sidebar',
    props: {
        sideBarHeight: {
            type: Number || null,
            default: null,
            required: false,
        },
    },
    computed: {
        addedStyle() {
            return `height: ${this.sideBarHeight}px; max-height: ${this.sideBarHeight}px;`;
        },
    },
});
